import { createSlice } from '@reduxjs/toolkit';
import { getActivePartsList } from '../../reducers/active/activeThunks';
import { handleRequestThunk } from '../handleRequestThunk';
import { commonInitialState } from '../../../utils/common/commonInitialState';
const SLICE_NAME = 'activeParts';

export const activePartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getActivePartsList });
    },
});

export const selectActiveParts = (state) => state.activeParts.data;

export const activeParts = activePartsSlice.reducer;
